import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { AppKitNetwork, sepolia } from '@reown/appkit/networks';
import { SocialProvider } from '@reown/appkit/react';
import i18next from 'i18next';

export const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';
if (!projectId) {
  throw new Error('Project ID is undefined');
}

export const metadata = {
  name: process.env.REACT_APP_NAME || 'My App',
  description:
    i18next &&
    i18next.isInitialized &&
    i18next.t('auth.messages.signature')
      ? i18next.t('auth.messages.signature')
      : '',
  url: window.location.origin,
  icons: ['https://app.follovers.art/assets/images/logo.webp'],
};

export const networks = [sepolia] as [AppKitNetwork, ...AppKitNetwork[]];

export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
  // CRA-safe config. No MetaMask injected provider.
  customRpcUrls: {},
});

export const socials: SocialProvider[] = ['google'];

export const includeWalletIds: string[] = [];
export const featuredWalletIds: string[] = [];

export const config = wagmiAdapter.wagmiConfig;
